import { apiRequest } from './apiUtils';
import { 
  SubmitDraftRequestDto, 
  SubmitDraftResponseDto,
  GenerateUploadUrlRequestDto,
  GenerateUploadUrlResponseDto,
  SubmitUGCContentRequestDto,
  SubmitUGCContentResponseDto,
  GenerateUGCUploadUrlRequestDto,
  GenerateUGCUploadUrlResponseDto,
} from '@foodfluence/shared';

/** `influencerId` is sent as X-Influencer-ID so staff acting as a creator reach that creator's collab. */
export const deliverableApi = {
  getUploadUrl: async (params: GenerateUploadUrlRequestDto, influencerId?: string): Promise<GenerateUploadUrlResponseDto> => {
    return apiRequest<GenerateUploadUrlResponseDto>({
      method: 'POST',
      endpoint: '/deliverables/generate-upload-url',
      data: params,
      influencerId,
    });
  },

  getUGCUploadUrl: async (params: GenerateUGCUploadUrlRequestDto, influencerId?: string): Promise<GenerateUGCUploadUrlResponseDto> => {
    return apiRequest<GenerateUGCUploadUrlResponseDto>({
      method: 'POST',
      endpoint: '/deliverables/generate-ugc-upload-url',
      data: params,
      influencerId,
    });
  },

  submitDraft: async (params: SubmitDraftRequestDto, influencerId?: string): Promise<SubmitDraftResponseDto> => {
    return apiRequest<SubmitDraftResponseDto>({
      method: 'POST',
      endpoint: '/deliverables/submit-draft',
      data: params,
      influencerId,
    });
  },

  submitPost: async (params: {
    collabId: string;
    deliverableKey: string;
    linkIndex: number;
    postUrl: string;
    influencerHandle: string;
    clientName: string;
    clientId: string;
  }, influencerId?: string): Promise<{ success: boolean }> => {
    return apiRequest<{ success: boolean }>({
      method: 'POST',
      endpoint: '/deliverables/submit-post',
      data: params,
      influencerId,
    });
  },

  submitPostAsFile: async (params:{
    collabId: string;
    deliverableKey: string;
    linkIndex: number;
    filePath: string;
  }, influencerId?: string): Promise<{ success: boolean }> => {
    return apiRequest<{ success: boolean }>({
      method: 'POST',
      endpoint: '/deliverables/submit-post-as-file',
      data: params,
      influencerId,
    });
  },

  submitUGCContent: async (params: SubmitUGCContentRequestDto, influencerId?: string): Promise<SubmitUGCContentResponseDto> => {
    return apiRequest<SubmitUGCContentResponseDto>({
      method: 'POST',
      endpoint: '/deliverables/submit-ugc-content',
      data: params,
      influencerId,
    });
  },

  notifyContentReview: async (params: { collabId: string }, influencerId?: string): Promise<{ success: boolean; message: string }> => {
    return apiRequest<{ success: boolean; message: string }>({
      method: 'POST',
      endpoint: '/deliverables/notify-content-review',
      data: params,
      influencerId,
    });
  },

  downloadInstagramStory: async (storyUrl: string, collabId: string, influencerId?: string): Promise<{ storyUrl: string; success: boolean }> => {
    return apiRequest<{ storyUrl: string; success: boolean }>({
      method: 'POST',
      endpoint: '/deliverables/download-instagram-story',
      data: { storyUrl, collabId },
      influencerId,
    });
  },

  downloadInstagramReel: async (reelUrl: string, collabId: string, influencerId?: string): Promise<{ reelUrl: string; success: boolean }> => {
    return apiRequest<{ reelUrl: string; success: boolean }>({
      method: 'POST',
      endpoint: '/deliverables/download-instagram-reel',
      data: { reelUrl, collabId },
      influencerId,
    });
  },

  downloadInstagramPost: async (postUrl: string, collabId: string, influencerId?: string): Promise<{ postUrl: string; contentType: 'image' | 'video'; success: boolean }> => {
    return apiRequest<{ postUrl: string; contentType: 'image' | 'video'; success: boolean }>({
      method: 'POST',
      endpoint: '/deliverables/download-instagram-post',
      data: { postUrl, collabId },
      influencerId,
    });
  },

  downloadTikTokPost: async (postUrl: string, collabId: string, influencerId?: string): Promise<{ postUrl: string; success: boolean }> => {
    return apiRequest<{ postUrl: string; success: boolean }>({
      method: 'POST',
      endpoint: '/deliverables/download-tiktok-post',
      data: { postUrl, collabId },
      influencerId,
    });
  },
}; 